const getAutoresNomes = (autores = []) => {
  let autoresNomes = ''
  autores.forEach((item, index) => {
    if (index + 1 < autores.length) {
      autoresNomes += item.autor.nome + ', '
    } else {
      autoresNomes += item.autor.nome
    }
  })
  return autoresNomes
}
export default getAutoresNomes
